Users: 
<select #sel [(ngModel)]="selectedUser" (change)="getUserActionLog()">
    <option value="">Select User</option>
    <option [ngValue]="user" *ngFor="let user of users">{{user.privateName}}</option>
</select>
<table>
    <thead>
        <th>Date time</th>
        <th>Action</th>
        <th>Data</th>
    </thead>
    <tbody>
        <tr *ngFor="let item of data">
            <td>{{item.actionTime | date: 'MM/dd/yyyy HH:mm'}}</td>
            <td>{{item.displayAction}}</td>
            <td>
                <span *ngFor="let obj of item.requestBody|keyvalue">
                    {{obj.key}}: <span style="font-weight: 600;">{{obj.value}}</span>
                </span>
            </td>
            <!-- <td>{{item.displayAction}}</td> -->
        </tr>
    </tbody>
</table>